import { CircularProgress } from '@mui/material';

type LoadingScreenProps = {
  /** Use for rare top-level boots only — avoid inside Layout (causes footer jump). */
  fullPage?: boolean;
};

const LoadingScreen = ({ fullPage = false }: LoadingScreenProps) => {
  return (
    <div
      className={
        fullPage
          ? 'flex min-h-screen items-center justify-center bg-white'
          : 'flex min-h-[40vh] items-center justify-center py-16'
      }
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <CircularProgress size={32} />
    </div>
  );
};

export default LoadingScreen;
